import React, { memo, useCallback, MouseEventHandler } from 'react'
import type { StyledSvgComponent } from '../../../types/svg'
import {
    RegionCountryItemHeader,
    RegionCountryName,
    RegionCountryNameLink,
    RegionCountryToggle,
    RegionCountryChevron,
    RegionCountryList,
    RegionCountryBlock,
    RegionItem,
    RegionItemLink,
    RegionItemText,
    IconImage,
} from './styles'
import ChevronDownIcon from '../../../assets/icons/chevron-down.svg'
import RightIcon from '../../../assets/icons/chevron-right.svg'
import ExternalLink from '../external-link'

interface Country {
    name: string
    link: string
    regions: Array<{ name: string; link: string }>
}

interface RegionCountryItemProps {
    country: Country
    isExpanded: boolean
    onToggle: (countryName: string) => void
}

const RegionCountryItem: React.FC<RegionCountryItemProps> = ({ country, isExpanded, onToggle }) => {
    const handleClick: MouseEventHandler<HTMLButtonElement> = useCallback(
        _e => {
            onToggle(country.name)
        },
        [country.name, onToggle],
    )

    return (
        <RegionCountryBlock>
            <RegionCountryItemHeader>
                <ExternalLink href={country.link} as={RegionCountryNameLink}>
                    <RegionCountryName>{country.name}</RegionCountryName>
                </ExternalLink>
                <RegionCountryToggle onClick={handleClick}>
                    <RegionCountryChevron isExpanded={isExpanded} as={ChevronDownIcon as StyledSvgComponent} />
                </RegionCountryToggle>
            </RegionCountryItemHeader>

            {isExpanded && (
                <RegionCountryList>
                    {country.regions.map(region => (
                        <RegionItem key={region.name}>
                            <ExternalLink href={region.link} as={RegionItemLink} noCrawl>
                                <RegionItemText>{region.name}</RegionItemText>
                                <IconImage as={RightIcon as StyledSvgComponent} />
                            </ExternalLink>
                        </RegionItem>
                    ))}
                </RegionCountryList>
            )}
        </RegionCountryBlock>
    )
}

export default memo(RegionCountryItem)
